import { render } from "./AutoComplete.vue?vue&type=template&id=bdfe0c44&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=bdfe0c44&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfe0c44"]])

export default __exports__